var Scinet = Scinet || {};
Scinet.selectric = Scinet.selectric || {};

Scinet.selectric.arrowButtonMarkup = "<i class='inline-icon icon-select'></i>";

Scinet.selectric.getRandomId = function () {
    var charSet = 'abcdefghijklmnopqrstuvwxyz';
    var randomString = '';
    for (var i = 0; i < 12; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return 'select_' + randomString;
};

$.fn.scinetSelectric = function () {
    this.selectric({
        arrowButtonMarkup: Scinet.selectric.arrowButtonMarkup,
        expandToItemText: true,

        optionsItemBuilder: function (itemData, element, index) {
            return '<span role="option" id="' + $(element).closest('select').attr('id') + '_option_' + index + '">' + itemData.text + '</span>';
        },

        onInit: function (element, data) {
            const $select = $(element);
            let selectId = $select.attr('id');

            if (!selectId) {
                selectId = Scinet.selectric.getRandomId();
                $select.attr('id', selectId);
            }

            const $label = $('label[for="' + selectId + '"]');
            const $wrapper = $select.closest(".selectric-wrapper");
            const $input = $wrapper.find(".selectric-input");
            const $combobox = $wrapper.find(".selectric");
            const $listbox = $wrapper.find(".selectric-items ul");

            if ($label.length && $input.length) {
                if (!$label.attr('id')) {
                    $label.attr('id', selectId + '-label');
                }
                $input.attr('aria-labelledby', $label.attr('id'));
                $listbox.attr('aria-labelledby', $label.attr('id'));
            }

            $input.attr({
                role: 'combobox',
                'aria-haspopup': 'listbox',
                'aria-controls': selectId + '_listbox',
                'aria-expanded': 'false',
                id: selectId + '_input'
            });

            $listbox
                .attr('role', 'listbox')
                .attr('id', selectId + '_listbox');

            $combobox
                .attr('aria-owns', selectId + '_listbox');
        },

        onOpen: function (element, data) {
            const $wrapper = $(element).closest(".selectric-wrapper");
            const $input = $wrapper.find(".selectric-input");
            $input.attr('aria-expanded', 'true');
        },

        onClose: function (element, data) {
            const $wrapper = $(element).closest(".selectric-wrapper");
            const $input = $wrapper.find(".selectric-input");
            $input.attr('aria-expanded', 'false');
        },

        onHighlight: function (element, data) {
            const $select = $(element);
            const selectId = $select.attr('id');
            const $wrapper = $select.closest(".selectric-wrapper");
            const $input = $wrapper.find(".selectric-input");

            $wrapper.find('[aria-selected]').removeAttr('aria-selected');

            const optionId = selectId + '_option_' + data.state.highlightedIdx;
            $wrapper.find('#' + optionId).attr('aria-selected', 'true');

            $input.attr('aria-activedescendant', optionId);
        }
    });
};
